import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getAdvancedAssetDepartments = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/filters-advanced-assets/departments`);
    return response.data;
  } catch (error) {
    console.error('Error fetching advanced asset departments:', error.response?.data || error);
    throw error;
  }
};
